module.exports = __webpack_public_path__ + "img/sport_LIGUE1.d6983dff.png";